import React from "react";
import styles from "./styles.module.scss";
import {t} from "i18next";
import LazyAssets from "@/app/utils/assets_widget";
import {TextMedium16} from "@/app/components/texts";
import classNames from "classnames";

interface CheckboxProps<T> {
  items: T[];
  onChange: (selected: T) => void;
  useS: boolean;
  onlyBox?: boolean;
  bg?: boolean;
  className?: string;
  value?: T[];
}

const Checkbox = <T, >({
                         items,
                         onChange,
                         useS = true,
                         onlyBox = false,
                         bg = false,
                         className,
                         value = []
                       }: CheckboxProps<T>) => {

  return (
    <div className={classNames(styles.items, className, {[styles.onlyBox]: onlyBox, [styles.bg]: bg})}>
      {items.map((item, index) => (
        <label key={index} className={styles.items__item}>
          <input
            type="checkbox"
            onChange={() => onChange(item)}
            className={styles.items__input}
            id={`checkbox-${index}`}
            checked={value.includes(item)}
          />
          <span className={styles.items__checkbox}>
            <LazyAssets.Select className={styles.items__checkmark}/>
          </span>
          {!onlyBox && <>
            {useS ? (
              <TextMedium16 text={t(String(item))}/>
            ) : (
              <TextMedium16 text={String(item)}/>
            )}
          </>}
        </label>
      ))}
    </div>
  );
};

export default Checkbox;